import dayjs from 'dayjs';
import { FC } from 'react';

// MUI
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

// screen
import { renderCell, SMALL_FONT_SIZE } from 'modules/map/components/pdf-print-form/utils';
import StyledTableHead from 'modules/map/components/pdf-print-form/styled-components/StyledTableHead';
import SizedText from 'modules/map/components/pdf-print-form/styled-components/SizedText';
import { StructuredData } from 'modules/map/components/daily-consolidate-invoice/types';

interface MenuInDayProp {
  data: StructuredData;
}

const MenuInDay: FC<MenuInDayProp> = ({ data: { data, metadata } }) => {
  const menuData = data.menu;
  const dishes = menuData.dishes;
  const minRowCount = 6;

  const showNote = (rowIndex: number) => {
    if (rowIndex !== 0) return '';
    return menuData.note || '';
  };

  const showDataInThirdColumn = (rowIndex: number) => {
    if (!metadata.hasAfternoon) return showNote(rowIndex);
    return menuData.afternoons[rowIndex] || '';
  };

  const rowCount = Math.max(
    dishes.length,
    metadata.hasAfternoon ? menuData.afternoons.length : 1,
    minRowCount
  );

  const firstColumnData = [
    '',
    dayjs(menuData.datetime).format('dddd'),
    dayjs(menuData.datetime).format('L'),
    '',
    'Sĩ số học sinh',
    menuData.studentCount != null ? menuData.studentCount.toString() : '',
  ];

  /**
   * trả ra mảng 2 chiều, trong đó mỗi phần tử là 1 mảng gồm 3 phần tử tương ứng với 3 cột của bảng trên PDF
   */
  const firstTableData = Array.from({ length: rowCount }, (_, rowIndex) => {
    return [
      firstColumnData[rowIndex] || '',
      dishes[rowIndex] || '',
      showDataInThirdColumn(rowIndex),
    ];
  });

  return (
    <Table sx={{ borderCollapse: 'separate' }}>
      <StyledTableHead>
        <TableRow>
          {[
            renderCell({ label: 'map.weekDayAndDate' }),
            renderCell({ label: 'map.menuUppercase', width: '50%' }),
            renderCell({
              label: metadata.hasAfternoon ? 'map.afternoonUppercase' : 'map.note',
              width: '30%',
            }),
          ].map((item, index) => {
            return (
              <TableCell key={index} className="whitespace-pre-wrap" style={{ width: item.width }}>
                <Typography
                  sx={{
                    fontSize: SMALL_FONT_SIZE,
                    fontWeight: 600,
                  }}
                >
                  {item.label}
                </Typography>
              </TableCell>
            );
          })}
        </TableRow>
      </StyledTableHead>
      <TableBody>
        {firstTableData.map((row, index) => (
          <TableRow key={index}>
            {row.map((cell, cellIndex) => (
              <TableCell key={cellIndex}>
                <SizedText
                  sx={{
                    fontSize: SMALL_FONT_SIZE,
                    textTransform: cell.includes('thứ') ? 'capitalize' : 'none',
                    fontWeight: 600,
                  }}
                >
                  {cell}
                </SizedText>
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default MenuInDay;
